import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';

import API from 'app/API';

import AutoComplete from '../field/AutoComplete';

const sourceContent = {
    type: 'type',
    published: 'date',
    lastseen: 'date',
    modified: 'date',
    title: 'string',
    bounty: 'float',
    cpe: 'string',
    order: 'root',
    'cvss.score': 'float'
};

const initialSourceContent = Object.keys(sourceContent).map((i) => ({ label: i, value: i }));

@inject('searchStore')
@inject('antiBotStore')
@observer
class SearchField extends React.Component {
    state = {
        searchText: '',
        dataSource: initialSourceContent
    };

    static propTypes = {
        classes: PropTypes.object,
        antiBotStore: PropTypes.any,
        searchStore: PropTypes.any,
        history: PropTypes.object,
        location: PropTypes.object,
        hintText: PropTypes.string,
        onUpdateInput: PropTypes.func,
        id: PropTypes.string,
        handleSubmit: PropTypes.func,
        ignoreChangeHistory: PropTypes.bool,
        skipStoreChange: PropTypes.bool,
        searchText: PropTypes.string,
        endAdornment: PropTypes.node,
        inputRef: PropTypes.object
    };

    /**
     * Change datasource here
     * @param searchText
     */
    onUpdateInput = (searchText) => {
        const { searchStore, onUpdateInput, skipStoreChange } = this.props;
        !skipStoreChange && searchStore.setQuery(searchText);
        onUpdateInput && onUpdateInput(searchText);

        API.fetch(API.SEARCH_AUTOCOMPLETE, {
            query: searchText
        }).then((r) => {
            this.setState({
                dataSource: r.data.suggestions.length
                    ? this.generateDataSource(r.data.suggestions)
                    : initialSourceContent,
                searchText: searchText
            });
        });
    };

    generateDataSource = (data) =>
        data.map((i) => ({
            label: i[0],
            value: i[0],
            style: i[1] ? { color: '#52188c' } : undefined
        }));

    /**
     * Item Selection
     * @param chosenItem
     */
    onItemSelect = (chosenItem) => {
        const searchText = this.state.searchText;

        if (this.state.searchText === chosenItem) {
            return this.doNewRequest(searchText);
        }
    };

    /**
     * Start polling
     */
    doRequest = (query, skip) => {
        if (!query) {
            return;
        }

        const { searchStore, handleSubmit, antiBotStore } = this.props;

        this.updateHistory(query, skip);

        searchStore.doRequest({ query });
        antiBotStore.randomCollectData();
        handleSubmit && this.props.handleSubmit();
    };

    doNewRequest = (query) => {
        const { searchStore, ignoreChangeHistory, antiBotStore } = this.props;

        searchStore.doRequest({ query });
        antiBotStore.randomCollectData();
        !ignoreChangeHistory && this.updateHistory(query);
    };

    updateHistory = (query, skip, history = this.props.history, location = this.props.location) => {
        let url = '/search'; // TODO clutch

        url += '?query=' + query;
        if (skip) {
            url += '&skip=' + skip;
        }

        history.push(url, '', url); //TODO
        location.query = {
            query: query,
            skip: skip
        };
    };

    render() {
        return (
            <AutoComplete
                className="vulners-search-field"
                type="search"
                id={this.props.id}
                hintText={this.props.hintText || window.i18n('findYourVulners')}
                value={this.props.searchText ?? this.props.searchStore.query}
                initialInputValue={this.props.searchText ?? this.props.searchStore.query}
                items={this.state.dataSource}
                onUpdateInput={this.onUpdateInput}
                onNewRequest={this.onItemSelect}
                InputProps={{ className: this.props.classes.input }}
                endAdornment={this.props.endAdornment}
                inputRef={this.props.inputRef}
            />
        );
    }
}

export default withRouter(SearchField);
